import { getPublicRouteUrl } from '@nackle/service-urls';
let currentenv =  window.location.hostname.toLowerCase().split( '.' ).find( function ( chunk ) {
    return [ 'localhost', 'ci', 'qa', 'pprd' ].indexOf( chunk ) >= 0;
} );

let isLocal = false;

if ( currentenv === 'localhost' ) {
    currentenv = 'qa';
    isLocal = true;
}

export const env = currentenv;



export const giftCodeExperienceURL = `${ getPublicRouteUrl( 'GIFT_CODE_EXP_API' ) }/api/v1`;
export const cmxSmartlingSyncUrl = getPublicRouteUrl( 'CMX_SMARTLING_SYNC' );

export function addCMXScript () {
    if ( isLocal ) {
        return; // for local dev, don't add smartling
    }
    if ( self !== top ) {
        return; // don't include smartling in an iframe
    }
    if ( env ) {
        const s = document.createElement( 'script' );
        s.setAttribute( 'src', `${ cmxSmartlingSyncUrl }/context-capture/gift-code-webapp/script` );
        document.body.appendChild( s );
    }
}